import { render, staticRenderFns } from "./JobTabs.vue?vue&type=template&id=639e9800"
import script from "./JobTabs.vue?vue&type=script&lang=js"
export * from "./JobTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports